<template>
  <div data-cy="benefit-container" class="max-w-screen-xl mx-auto px-4">
    <h1 v-if="largeHeader" class="text-center pb-8 uppercase">
      {{ component.title }}
    </h1>
    <p
      v-else
      class="text-2xl/[1.2] max-sm:text-xl/[1.2] mb-2 font-bold uppercase"
      role="heading"
      aria-level="2"
    >
      {{ component.title }}
    </p>

    <div
      data-cy="benefit-section-wrapper"
      class="flex flex-wrap text-center py-6 gap-8"
      :class="centerItems ? 'justify-center' : 'justify-start'"
    >
      <strapi-benefits-item
        v-for="benefit in safeBenefits"
        :key="benefit.id ?? benefit.title ?? Math.random()"
        data-cy="benefit-section-benefit-item"
        class="w-full md:w-[calc(50%-1rem)] lg:w-[calc(33.333%-1.34rem)] xl:w-[calc(25%-1.5rem)]"
        :benefit="benefit"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StrapiBenefit, StrapiBenefitList } from '~/apollo/types/types';

const props = withDefaults(
  defineProps<{
    component: StrapiBenefitList | StrapiBenefit;
    largeHeader?: boolean;
    centerItems?: boolean;
  }>(),
  {
    largeHeader: false,
    centerItems: true,
  },
);

const safeBenefits = computed(
  () =>
    (props.component as StrapiBenefitList | StrapiBenefit)?.benefits?.filter(
      Boolean,
    ) ?? [],
);
</script>
